import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

type AnimatedProgressArcProps = {
    // Number between 0 and 1 as a percentile complete.
    targetProgress: number
    // Text to display at the target point on the arc.
    targetText?: string
    // Content to display on the "hill" beneath the arc.
    subArcContent?: React.ReactNode
}

const ARC_START = 'M 0,40'
const ARC_PATH = 'M 0,40 C 100,0 310,0 410,45'

export default function AnimatedProgressArc({
    targetProgress,
    targetText,
    subArcContent: subContent,
}: AnimatedProgressArcProps) {
    const [progressPath, setProgressPath] = useState(ARC_START)
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        setProgressPath(ARC_PATH)
        setProgress(Math.min(targetProgress, 1))
    }, [targetProgress])

    return (
        <div className="relative">
            <motion.svg className="h-full pt-[20px]" id="semicircle-border" viewBox="0 0 410 175">
                <defs>
                    <motion.linearGradient id="borderGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{ stopColor: 'rgb(255,255,255)', stopOpacity: 0.05 }} />
                        <stop offset="50%" style={{ stopColor: 'rgb(255,255,255)', stopOpacity: 0.75 }} />
                    </motion.linearGradient>
                </defs>
                <path d="M 0,40 C 100,0 310,0 410,45 L 410,175 L 0,175" fill="rgba(255,255,255,0.05)" />
                <path d="M 0,40 C 100,0 310,0 410,45" fill="none" stroke="white" strokeOpacity="0.1" strokeWidth="1" />
                <motion.path
                    fill="none"
                    stroke="url(#borderGradient)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    initial={{ pathLength: 0 }}
                    animate={{
                        pathLength: 0.85 * progress,
                        d: progressPath,
                    }}
                    transition={{ duration: 0.85, ease: 'easeInOut' }}
                />
                <circle
                    cx={410 * 0.85}
                    cy={175 * 0.148}
                    r="3"
                    fill="white"
                    stroke="rgba(0,0,0)"
                    strokeWidth="1"
                    strokeLinecap="round"
                />
            </motion.svg>
            <div className="text-[12px] absolute right-[42px] top-[20px] rotate-11 opacity-50">{targetText}</div>
            {subContent && (
                <div className="absolute top-0 left-0 right-0 flex justify-center items-center pt-[20px]">
                    {subContent}
                </div>
            )}
        </div>
    )
}
